import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "./api";

/** Auto-track page views on every route change. */
export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    track("page_view", location.pathname);
  }, [location.pathname]);
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("pulse_user") || "{}");
  } catch {
    return {};
  }
}

export function isOwner() {
  return getUser().role === "owner";
}
